<template>
  <div
    class="mr-1 mb-1 cursor-pointer rounded px-3 py-1 sm:whitespace-nowrap"
    :class="
      isSelected
        ? 'bg-brand-500 text-white'
        : 'bg-gray-100 text-gray-500 shadow-inner hover:text-black'
    "
  >
    <slot></slot>
  </div>
</template>

<script>
export default {
  props: {
    isSelected: { type: Boolean },
  },
}
</script>
